var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"flex-center",attrs:{"visible":_vm.showDialog,"title":_vm.title,"lock-scroll":false,"close-on-click-modal":false,"width":_vm.width,"center":"","before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.showDialog=$event},"close":function($event){return _vm.emitInput(false)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }